/**
 * Centralized environment configuration.
 *
 * All env var access goes through this module so the fallback values
 * live in exactly one place. Import from '@/config/env' — never read
 * import.meta.env.VITE_* directly in service/hook files.
 */

export const API_BASE_URL: string =
  import.meta.env.VITE_API_URL || 'http://localhost:8081'

export const AI_MOCK_FALLBACK: boolean =
  import.meta.env.VITE_AI_MOCK_FALLBACK !== undefined
    ? import.meta.env.VITE_AI_MOCK_FALLBACK === 'true'
    : import.meta.env.DEV

/**
 * Phase 4d — dashboard flashcard engagement tile is gated behind a feature
 * flag during the pilot window. Default off; flip via env to surface the
 * tile in staging while we ramp data and again in production once the
 * pilot decision rubric is met. Defaults to dev mode for visibility while
 * iterating locally.
 */
export const FLASHCARD_TILE_ENABLED: boolean =
  import.meta.env.VITE_FLASHCARD_TILE_ENABLED !== undefined
    ? import.meta.env.VITE_FLASHCARD_TILE_ENABLED === 'true'
    : import.meta.env.DEV
